<template lang="pug">
  .tabs
    .tabs__nav(
      v-if="tabs.length > 1"
    )
      button.tabs__nav-button(
        type="button",
        v-for="tab in tabs",
        :class="{ 'active': tab.active }",
        @click="activate(tab)"
      ) {{ tab.heading }}
    .tabs__content
      slot
</template>

<script>
  export default {
    name: 'Tabs',
    data() {
      return {
        tabs: [],
      };
    },
    methods: {
      addTab(newTab) {
        this.tabs.push(newTab);
      },
      removeTab(tabToRemove) {
        const index = this.tabs.findIndex((tab) => tab.heading === tabToRemove.heading);
        this.tabs.splice(index, 1);
      },
      activate({ heading }) {
        this.tabs.forEach((tab) => {
          tab.$set(tab, 'active', Boolean(heading === tab.heading));
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .tabs {
    padding-bottom: 50px;
  }

  .tabs__nav {
    margin-bottom: $content-gutter;
  }

  .tabs__nav-button {
    cursor: pointer;
    background-color: transparent;
    position: relative;
    margin: 5px 20px 5px 0px;
    line-height: 1.5;
    padding: 0;
    border: 0;
    transition: 0.3s ease all;

    &:hover {}

    &:focus {
      outline: none;
    }

    &.active {}
  }
</style>
